import { gql } from '@grandvisionhq/graphql';
import { orderFragment } from '../fragments/line-item.js';

const GET_ORDER_DETAILS = gql`
  query getOrderDetails($orderNumber: ID!) {
    me {
      id
      order(orderNumber: $orderNumber) {
        ...OrderFragment
      }
    }
  }
  ${orderFragment}
`;

export { GET_ORDER_DETAILS };
//# sourceMappingURL=get-order-details.js.map
